import React from 'react';
import {Container, Row, Col} from 'reactstrap';

export default function GenericError(props) {
    return (
        <Container className="generic-error-container">
            <Row>
                <Col className="generic-error-head">System Error {props.msg}</Col>
            </Row>
            <Row>    
                <Col className="generic-error-body">Error loading Global Office Rent Tracker. </Col>
            </Row>
            <Row>
                <Col className="generic-error-body">Our support team has been notified. </Col>
            </Row>
            <Row>
                <Col className="generic-error-body">Please try again later.</Col>
            </Row>
        </Container>
    )
}
